import { Suspense } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import FloatingButtons from '../../../components/feature/FloatingButtons';

const HirdavatKKDPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="relative h-[60vh] min-h-[500px] bg-gradient-to-r from-indigo-900 via-indigo-800 to-blue-900 overflow-hidden mt-20">
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-10 left-10 w-32 h-32 border-2 border-white rounded-full animate-pulse"></div>
          <div className="absolute bottom-20 right-20 w-40 h-40 border-2 border-white rounded-full animate-pulse"></div>
        </div>
        
        <div className="relative z-10 container mx-auto px-6 h-full flex items-center">
          <div className="text-white max-w-3xl">
            <div className="flex items-center mb-6">
              <div className="w-16 h-16 flex items-center justify-center mr-4">
                <i className="ri-shield-user-line text-6xl text-indigo-300"></i>
              </div>
              <h1 className="text-5xl md:text-6xl font-bold">Hırdavat ve KKD</h1>
            </div>
            <p className="text-xl md:text-2xl text-indigo-100 leading-relaxed">
              Kişisel koruyucu donanım ve iş güvenliği malzemeleri seçimi, temini ve danışmanlık hizmetleri
            </p>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          {/* Services Section */}
          <section className="py-20 bg-white">
            <div className="container mx-auto px-4">
              <div className="text-center mb-16">
                <span className="text-teal-600 font-medium text-lg">Hizmetlerimiz</span>
                <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mt-2 mb-6">Hırdavat ve KKD Danışmanlığı Kapsamı</h2>
                <p className="text-gray-600 text-lg max-w-3xl mx-auto">
                  İş güvenliği ekipmanları ve kişisel koruyucu donanımlar konusunda kapsamlı danışmanlık ve tedarik hizmetleri sunuyoruz.
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 auto-rows-fr">
                {/* Card 1 */}
                <div className="bg-gradient-to-br from-sky-50 to-sky-100 rounded-2xl p-8 border border-sky-200 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 flex flex-col h-full">
                  <div className="w-20 h-20 bg-gradient-to-br from-sky-500 to-sky-600 rounded-full flex items-center justify-center mx-auto mb-6">
                    <div className="w-12 h-12 flex items-center justify-center">
                      <i className="ri-shield-user-line text-3xl text-white"></i>
                    </div>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-800 mb-4 text-center">KKD Seçimi ve Danışmanlığı</h3>
                  <p className="text-gray-700 leading-relaxed text-center flex-grow">
                    İş yerinizin risk analizine göre en uygun kişisel koruyucu donanımların seçimi ve kullanımı konusunda danışmanlık veriyoruz.
                  </p>
                </div>

                {/* Card 2 */}
                <div className="bg-gradient-to-br from-amber-50 to-amber-100 rounded-2xl p-8 border border-amber-200 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 flex flex-col h-full">
                  <div className="w-20 h-20 bg-gradient-to-br from-amber-500 to-amber-600 rounded-full flex items-center justify-center mx-auto mb-6">
                    <div className="w-12 h-12 flex items-center justify-center">
                      <i className="ri-hard-drive-2-line text-3xl text-white"></i>
                    </div>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-800 mb-4 text-center">İş Güvenliği Ekipmanları</h3>
                  <p className="text-gray-700 leading-relaxed text-center flex-grow">
                    Yangın söndürme sistemleri, acil durum ekipmanları ve güvenlik donanımları tedarik ve kurulum hizmetleri sunuyoruz.
                  </p>
                </div>

                {/* Card 3 */}
                <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-2xl p-8 border border-blue-200 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 flex flex-col h-full">
                  <div className="w-20 h-20 bg-gradient-to-br from-blue-500 to-blue-600 rounded-full flex items-center justify-center mx-auto mb-6">
                    <div className="w-12 h-12 flex items-center justify-center">
                      <i className="ri-tools-line text-3xl text-white"></i>
                    </div>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-800 mb-4 text-center">Hırdavat Malzemeleri</h3>
                  <p className="text-gray-700 leading-relaxed text-center flex-grow">
                    İş güvenliği için gerekli tüm hırdavat malzemelerinin tedariki ve montaj hizmetlerini sağlıyoruz.
                  </p>
                </div>

                {/* Card 4 */}
                <div className="bg-gradient-to-br from-orange-50 to-orange-100 rounded-2xl p-8 border border-orange-200 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 flex flex-col h-full">
                  <div className="w-20 h-20 bg-gradient-to-br from-orange-500 to-orange-600 rounded-full flex items-center justify-center mx-auto mb-6">
                    <div className="w-12 h-12 flex items-center justify-center">
                      <i className="ri-checkbox-circle-line text-3xl text-white"></i>
                    </div>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-800 mb-4 text-center">CE Belgeli Ürünler</h3>
                  <p className="text-gray-700 leading-relaxed text-center flex-grow">
                    Tüm ürünlerimiz CE belgeli ve uluslararası standartlara uygun olarak tedarik edilmektedir.
                  </p>
                </div>

                {/* Card 5 */}
                <div className="bg-gradient-to-br from-rose-50 to-rose-100 rounded-2xl p-8 border border-rose-200 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 flex flex-col h-full">
                  <div className="w-20 h-20 bg-gradient-to-br from-rose-500 to-rose-600 rounded-full flex items-center justify-center mx-auto mb-6">
                    <div className="w-12 h-12 flex items-center justify-center">
                      <i className="ri-user-settings-line text-3xl text-white"></i>
                    </div>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-800 mb-4 text-center">KKD Kullanım Eğitimi</h3>
                  <p className="text-gray-700 leading-relaxed text-center flex-grow">
                    Tedarik edilen kişisel koruyucu donanımların doğru kullanımı konusunda çalışanlarınıza eğitim veriyoruz.
                  </p>
                </div>

                {/* Card 6 */}
                <div className="bg-gradient-to-br from-red-50 to-red-100 rounded-2xl p-8 border border-red-200 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 flex flex-col h-full">
                  <div className="w-20 h-20 bg-gradient-to-br from-red-500 to-red-600 rounded-full flex items-center justify-center mx-auto mb-6">
                    <div className="w-12 h-12 flex items-center justify-center">
                      <i className="ri-refresh-line text-3xl text-white"></i>
                    </div>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-800 mb-4 text-center">Periyodik Kontrol ve Bakım</h3>
                  <p className="text-gray-700 leading-relaxed text-center flex-grow">
                    Tedarik edilen ekipmanların periyodik kontrol ve bakım hizmetlerini düzenli olarak gerçekleştiriyoruz.
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* KKD Kategorileri */}
          <div className="mb-20">
            <div className="text-center mb-12">
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">Kişisel Koruyucu Donanım Kategorileri</h2>
              <p className="text-gray-700 text-lg max-w-3xl mx-auto">
                İş güvenliği standartlarına uygun, kaliteli ve sertifikalı KKD ürünleri
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {[
                { icon: 'ri-shield-user-line', title: 'Baş Koruma', desc: 'Baret, kask ve başlık çeşitleri', items: ['İş bareti', 'Elektrik bareti', 'Kaynak başlığı'] },
                { icon: 'ri-eye-line', title: 'Göz ve Yüz Koruma', desc: 'Gözlük ve siperlik ürünleri', items: ['Koruyucu gözlük', 'Kaynak gözlüğü', 'Yüz siperi'] },
                { icon: 'ri-lungs-line', title: 'Solunum Koruma', desc: 'Maske ve respiratör sistemleri', items: ['Toz maskesi', 'Gaz maskesi', 'Tam yüz maskesi'] },
                { icon: 'ri-hand-heart-line', title: 'El Koruma', desc: 'İş eldiveni çeşitleri', items: ['Deri eldiven', 'Kimyasal eldiven', 'Kesim önleyici eldiven'] },
                { icon: 'ri-footprint-line', title: 'Ayak Koruma', desc: 'İş ayakkabısı ve bot modelleri', items: ['Çelik burunlu bot', 'Elektrikçi ayakkabısı', 'Kimyasal bot'] },
                { icon: 'ri-t-shirt-line', title: 'Vücut Koruma', desc: 'İş kıyafeti ve önlük çeşitleri', items: ['İş tulumu', 'Reflektörlü yelek', 'Kaynak önlüğü'] }
              ].map((category, index) => (
                <div key={index} className="bg-white rounded-2xl p-8 shadow-xl border-2 border-gray-200 hover:shadow-2xl hover:border-orange-300 transition-all duration-300 transform hover:-translate-y-2 flex flex-col h-full">
                  <div className="w-20 h-20 bg-orange-100 rounded-2xl flex items-center justify-center mx-auto mb-6 flex-shrink-0">
                    <div className="w-12 h-12 flex items-center justify-center">
                      <i className={`${category.icon} text-4xl text-orange-600`}></i>
                    </div>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 text-center mb-4">{category.title}</h3>
                  <p className="text-gray-700 text-center mb-6">{category.desc}</p>
                  <ul className="text-sm text-gray-700 space-y-2 text-left mt-auto">
                    {category.items.map((item, idx) => (
                      <li key={idx} className="flex items-start">
                        <span className="text-orange-600 mr-2">•</span>
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>

          {/* Hardware Section */}
          <div className="mb-20">
            <div className="text-center mb-12">
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">İş Güvenliği Hırdavat Malzemeleri</h2>
              <p className="text-gray-700 text-lg max-w-3xl mx-auto">
                İşyeri güvenliği için gerekli tüm ikaz, uyarı ve acil durum ekipmanları
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {[
                {
                  icon: 'ri-alert-line',
                  title: 'İkaz ve Uyarı Sistemleri',
                  color: 'orange',
                  items: ['Güvenlik Levhaları ve Tabelaları', 'Reflektörlü Bant ve Şeritler', 'Uyarı Konileri ve Bariyerler', 'Fotolüminesans İşaretler', 'Zemin İşaretleme Bantları']
                },
                {
                  icon: 'ri-fire-line',
                  title: 'Yangın Güvenlik Ekipmanları',
                  color: 'red',
                  items: ['Yangın Söndürme Tüpleri', 'Yangın Battaniyeleri', 'Yangın Dolapları', 'Acil Durum Aydınlatma', 'Duman Dedektörleri']
                },
                {
                  icon: 'ri-first-aid-kit-line',
                  title: 'İlkyardım Malzemeleri',
                  color: 'amber',
                  items: ['İlkyardım Çantaları', 'Sedye ve Taşıma Ekipmanları', 'Göz Duşu ve Yıkama İstasyonları', 'Acil Durum Duş Sistemleri', 'Defibrilatör (AED)']
                },
                {
                  icon: 'ri-lock-line',
                  title: 'Güvenlik ve Kilitleme',
                  color: 'sky',
                  items: ['LOTO Kilitleme Sistemleri', 'Güvenlik Asma Kilitleri', 'Etiketleme Sistemleri', 'Acil Stop Düğmeleri', 'Makine Koruma Sistemleri']
                }
              ].map((section, index) => (
                <div key={index} className="bg-white border-2 border-gray-200 rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300">
                  <div className="flex items-start mb-6">
                    <div className={`w-12 h-12 bg-${section.color}-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0`}>
                      <div className="w-8 h-8 flex items-center justify-center">
                        <i className={`${section.icon} text-2xl text-${section.color}-600`}></i>
                      </div>
                    </div>
                    <div>
                      <h3 className="text-xl font-bold text-gray-900 mb-2">{section.title}</h3>
                    </div>
                  </div>
                  <ul className="space-y-3 text-gray-700">
                    {section.items.map((item, idx) => (
                      <li key={idx} className="flex items-start">
                        <div className="w-5 h-5 flex items-center justify-center mt-0.5 mr-3">
                          <i className={`ri-arrow-right-s-line text-${section.color}-500`}></i>
                        </div>
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>

          {/* CTA Section */}
          <div className="bg-gradient-to-r from-indigo-600 via-indigo-700 to-blue-700 rounded-3xl p-12 md:p-16 text-center shadow-2xl">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">İşyeriniz İçin Doğru KKD Seçimi</h2>
            <p className="text-indigo-100 text-lg md:text-xl mb-8 max-w-2xl mx-auto">
              Uzman kadromuz işyerinizi ziyaret ederek risk analizi yapar ve ihtiyacınıza uygun ekipmanları belirler
            </p>
            <Link 
              to="/iletisim"
              className="inline-flex items-center bg-white text-indigo-600 px-10 py-5 rounded-2xl font-bold text-lg hover:bg-indigo-50 transition-all duration-300 transform hover:scale-105 shadow-xl whitespace-nowrap cursor-pointer"
            >
              <span>Teklif Alın</span>
              <div className="w-6 h-6 flex items-center justify-center ml-3">
                <i className="ri-arrow-right-line text-2xl"></i>
              </div>
            </Link>
          </div>
        </div>
      </section>

      <Footer />
      <FloatingButtons />
    </div>
  );
};

export default HirdavatKKDPage;
